const backgroundData = {
  game: [
    {
      style: "top: 40vh;",
    },
    {
      style: "top: 80vh;",
    },
  ],
};

export default backgroundData;
